import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';
import { BadgeComponent, ButtonComponent, IconButtonComponent } from '@recruitee/user-interface';

import { FeatureTooltipComponent } from './feature-tooltip.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonComponent,
    I18nModule,
    BadgeComponent,
    IconButtonComponent,
    FeatureTooltipComponent,
  ],
  exports: [FeatureTooltipComponent],
})
export class FeatureTooltipModule {}

export { FeatureTooltipComponent };
